import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Profile API
export const profileAPI = {
  getProfile: () => axios.get(`${API_URL}/profile`),
  updateProfile: (data) => axios.put(`${API_URL}/profile`, data)
};

// Films API
export const filmsAPI = {
  getAll: () => axios.get(`${API_URL}/films`),
  getById: (id) => axios.get(`${API_URL}/films/${id}`),
  create: (data) => axios.post(`${API_URL}/films`, data),
  update: (id, data) => axios.put(`${API_URL}/films/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/films/${id}`)
};

// Gallery API
export const galleryAPI = {
  getAll: () => axios.get(`${API_URL}/gallery`),
  getById: (id) => axios.get(`${API_URL}/gallery/${id}`),
  getByFilm: (filmId) => axios.get(`${API_URL}/gallery/film/${filmId}`),
  create: (data) => axios.post(`${API_URL}/gallery`, data),
  update: (id, data) => axios.put(`${API_URL}/gallery/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/gallery/${id}`)
};

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axios.post(`${API_URL}/upload/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  uploadImages: (files) => {
    const formData = new FormData();
    files.forEach(file => formData.append('images', file));
    return axios.post(`${API_URL}/upload/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteFile: (filename) => axios.delete(`${API_URL}/upload/${filename}`)
};
